// extracted by mini-css-extract-plugin
export var emailBlockLink = "_lm-0";